import { request } from "@umijs/max";

/** 提交反馈 */
export async function submitFeedback(data: {
  category: string;
  content: string;
  contactEmail?: string;
  pageUrl?: string;
  browserInfo?: string;
  screenshotUrls?: string[];
  npsScore?: number;
}) {
  return request<API.Feedback>("/app/feedback", {
    method: "POST",
    data,
  });
}

/** 获取我的反馈列表 */
export async function getMyFeedbackList(params?: {
  page?: number;
  size?: number;
}) {
  return request<API.PageResult<API.Feedback>>("/app/feedback", {
    method: "GET",
    params,
  });
}

/** 获取最近一次 NPS 反馈时间 */
export async function getLatestNpsTime() {
  return request<{ latestNpsTime: string }>("/app/feedback/nps-latest", {
    method: "GET",
  });
}

/** 上传反馈截图 */
export async function uploadFeedbackScreenshot(file: File) {
  const formData = new FormData();
  formData.append("file", file);
  return request<string>("/app/upload/image/feedback", {
    method: "POST",
    data: formData,
  });
}
